import * as React from 'react';

function SmartLockersIcon({ color = '#545454', ...props }) {
	return (
		<svg xmlns='http://www.w3.org/2000/svg' width={18} height={18} viewBox='0 0 14 22' fill='none' {...props}>
			<path
				d='M9 13h.01M5 5h4M5 9h4M3 1h8a2 2 0 012 2v16a2 2 0 01-2 2H3a2 2 0 01-2-2V3a2 2 0 012-2z'
				stroke={color}
				strokeWidth={2}
				strokeLinecap='round'
				strokeLinejoin='round'
			/>
		</svg>
	);
}

export default SmartLockersIcon;
